const sample = {
  desc: 'Sie sind noch unschlüssig bzgl. Material und Farbe? </br> Kein Problem, wir schicken Ihnen gerne ein <strong>kostenloses Muster</strong> zu.',
  contact: 'Setzen Sie sich diesbezüglich direkt mit uns in Verbindung'
}

export default {
  sample
}
